import { gql } from "@apollo/client";

// QUERY_BOOKMARKS
export const QUERY_BOOKMARKS = gql`
  query bookmarksPageableByUserId($staffId: ID!, $size: Int!) {
    bookmarks: bookmarks_connection(
      pagination: { pageSize: $size }
      sort: "createdAt:desc"
      filters: { staff: { documentId: { eq: $staffId } } }
    ) {
      data {
        attributes {
          relationId
          metadata
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

//QUERY_ALL_BOOKMARKS
export const QUERY_ALL_BOOKMARKS = gql`
  query allBookmarksPageableByUserId(
    $filters: BookmarkFiltersInput
    $size: Int!
    $page: Int
  ) {
    bookmarks: bookmarks_connection(
      pagination: { pageSize: $size, page: $page }
      sort: "createdAt:desc"
      filters: $filters
    ) {
      data {
        documentId
        attributes {
          relationId
          metadata
          category
          knowledgeBaseType {
            data {
              attributes {
                type
              }
            }
          }
        }
      }
      meta {
        pagination {
          total
          page
          pageCount
        }
      }
    }
  }
`;

export const QUERY_EXIST_BOOKMARK = gql`
  query existByRelationId($relationId: String!, $staffId: ID!) {
    bookmarks: bookmarks_connection(
      filters: {
        relationId: { eq: $relationId }
        staff: { documentId: { eq: $staffId } }
      }
    ) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;

export const QUERY_FIND_BOOKMARK = gql`
  query findByRelationId($relationId: String!, $staffId: ID!) {
    bookmarks: bookmarks_connection(
      filters: {
        relationId: { eq: $relationId }
        staff: { documentId: { eq: $staffId } }
      }
    ) {
      data {
        id
        documentId
      }
    }
  }
`;

export const QUERY_BOOKMARK_PAGE = gql`
  query bookmarkPage {
    bookmarkPage {
      pageTitle
      description
      openButtonTxt
      searchPlaceholder
      loadingText
      emptyStateText
      removeFromBookmarksText
      goToResourceText
      tabKnowledgeBase
      tabPodcast
      tabLearn
      tabResource
      sections {
        key
        value
      }
    }
  }
`;

export const QUERY_MY_BOOKMARKS = gql`
  query fetchMyBookmarks(
    $category: BookmarkCategory
    $knowledgeBaseType: String
    $relationId: String
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    fetchMyBookmarks(
      category: $category
      knowledgeBaseType: $knowledgeBaseType
      relationId: $relationId
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      results {
        relationId
        metadata
        category
        knowledgeBaseType {
          type
        }
      }
      types
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
`;
